var exports = {
  "v2": "v2__P-oOcR",
  "S": "featuredItem__6zKZ_w",
};

module.exports = exports;
